export class MetadatiProtocolloGescorDTO {
  numero: string;

  anno: number;

  data: string;

  tipo: string;

  tipoAbbreviato: string;
}
